import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PerimeterSeatingIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M20.2 8.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM20.2 12.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM19.1 17.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM5.1 9.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM16.1 6.2a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM12.1 6.2a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM7 5.1a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM5.1 13.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM16.1 20.2a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM12.1 20.2a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM7 19.1a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM5.1 17.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        }),
                        _jsx("path", {
                            d: "M23 2a1 1 0 00-1-1H2a1 1 0 00-1 1v20a1 1 0 001 1h20a1 1 0 001-1V2zM3 3h18v18H3V3z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        })
                    ]
                })
            })
        ]
    });
};
PerimeterSeatingIcon.isCarinaIcon = true;
export default PerimeterSeatingIcon;
